// stitchCornrowOptions.js
export const STITCH_CORNROW_PRICE_PER_BRAID = 20;

export const stitchCornrowCountOptions = [
  { value: "4", label: "4 braids", price: 80 },
  { value: "6", label: "6 braids", price: 120 },
  { value: "8", label: "8 braids", price: 160 },
  { value: "10", label: "10 braids", price: 200 },
  { value: "12", label: "12 braids", price: 240 },
];